<template>
  <div class="sign-in-con">
    <ArcoTypographyTitle :heading="3">
      {{$t('signIn.formTitle')}}
    </ArcoTypographyTitle>
    <div>
      <ArcoTabs v-model:active-key="activeLoginType">
        <ArcoTabPane key="withPhone" :title="$t('signIn.withPhone')" v-if="!disableSMSLogin" :disabled="route.query?.email">
          <ArcoForm
            ref="formRef"
            name="custom-validation"
            :model="forgetForm"
            :rules="forgetRules"
            v-bind="layout"
            class="forget-form"
            @submit="signIn($event, true)"
            autocomplete="off"
          >
            <ArcoFormItem
              :label="$t('signIn.phone')"
              field="phone">
              <ArcoInput
                v-model="forgetForm.phone"
                autocomplete="off"
                :placeholder="$t('signIn.phoneNullError')">
                <template #prefix>
                  <div style="color: rgba(0,0,0,0.4)">
                    +86
                  </div>
                </template>
              </ArcoInput>
            </ArcoFormItem>
            <ArcoFormItem
              :label="$t('signIn.verificationCode')"
              field="smsCode">
              <ArcoRow :gutter="16" style="width: calc(100% + 16px)">
                <ArcoCol :xs="15" :sm="17" :md="17" :lg="17" :xl="17" :xxl="17">
                  <ArcoInput
                    v-model="forgetForm.smsCode"
                    :placeholder="$t('signIn.verificationTips')"
                  ></ArcoInput>
                </ArcoCol>
                <ArcoCol :xs="9" :sm="7" :md="7" :lg="7" :xl="7" :xxl="7">
                  <ArcoButton
                    style="width:100%"
                    type="outline"
                    @click="getCode"
                    v-if="canGetCode">
                    {{$t('login.getCode')}}
                  </ArcoButton>
                  <ArcoButton
                    style="width:100%"
                    v-else
                    disabled
                    class="time-left-text">{{timeLeft}} {{$t('forgetPassword.second')}}</ArcoButton>
                </ArcoCol>
              </ArcoRow>
            </ArcoFormItem>
            <ArcoFormItem
              field="username"
              trigger="blur"
              label="First Name"
              autocomplete="off"
              :rules="[{required:true,message:'Enter Your First Name'}]"
              v-if="$store.state.locale === 'enUS'">
              <ArcoInput v-model="forgetForm.username" placeholder="Please Enter Your First Name" />
            </ArcoFormItem>
            <ArcoFormItem
              field="lastname"
              trigger="blur"
              label="Last Name"
              autocomplete="off"
              :rules="[{required:true,message:'Enter Your Last Name'}]"
              v-if="$store.state.locale === 'enUS'">
              <ArcoInput v-model="forgetForm.lastname" placeholder="Please Enter Your Last Name" />
            </ArcoFormItem>
            <ArcoFormItem
              v-else
              :label="$t('signIn.name')"
              field="username">
              <ArcoInput
                v-model="forgetForm.username"
                autocomplete="off"
                :placeholder="$t('signIn.nameTips')">
              </ArcoInput>
            </ArcoFormItem>
            <ArcoFormItem
              :label="$t('signIn.enterPassword')"
              field="password">
              <ArcoInputPassword
                v-model="forgetForm.password"
                autocomplete="off"
                :placeholder="$t('signIn.passwordTips')"/>
            </ArcoFormItem>
            <ArcoFormItem
              :label="$t('signIn.confirmPassword')"
              field="confirmPassword">
              <ArcoInputPassword
                v-model="forgetForm.confirmPassword"
                autocomplete="off"
                :placeholder="$t('signIn.confirmPasswordTips')"/>
            </ArcoFormItem>
            <ArcoFormItem>
              <a-button type="primary" html-type="submit" style="width:100%;margin-top:10px" size="large">
                {{$t('signIn.signIn')}}
              </a-button>
            </ArcoFormItem>
          </ArcoForm>
        </ArcoTabPane>
        <ArcoTabPane key="withEmail" :title="$t('signIn.withEmail')">
          <ArcoForm
            name="custom-validation"
            :model="forgetForm"
            :rules="forgetRules"
            v-bind="layout"
            class="forget-form"
            @submit="signIn($event, false)"
            autocomplete="off"
          >
            <ArcoFormItem
              :label="$t('signIn.email')"
              field="email">
              <ArcoInput
                v-model="forgetForm.email"
                autocomplete="off"
                :disabled="isInit"
                :placeholder="$t('signIn.emailTips')"/>
            </ArcoFormItem>
            <ArcoFormItem
              field="username"
              trigger="blur"
              label="First Name"
              autocomplete="off"
              :rules="[{required:true,message:'Enter Your First Name'}]"
              v-if="$store.state.locale === 'enUS'">
              <ArcoInput v-model="forgetForm.username" placeholder="Please Enter Your First Name" />
            </ArcoFormItem>
            <ArcoFormItem
              field="lastname"
              trigger="blur"
              label="Last Name"
              autocomplete="off"
              :rules="[{required:true,message:'Enter Your Last Name'}]"
              v-if="$store.state.locale === 'enUS'">
              <ArcoInput v-model="forgetForm.lastname" placeholder="Please Enter Your Last Name" />
            </ArcoFormItem>
            <ArcoFormItem
              v-else
              :label="$t('signIn.name')"
              field="username">
              <ArcoInput
                v-model="forgetForm.username"
                autocomplete="off"
                :placeholder="$t('signIn.nameTips')">
              </ArcoInput>
            </ArcoFormItem>
            <ArcoFormItem
              :label="$t('signIn.enterPassword')"
              field="password">
              <ArcoInputPassword
                v-model="forgetForm.password"
                autocomplete="off"
                :placeholder="$t('signIn.passwordTips')"/>
            </ArcoFormItem>
            <ArcoFormItem
              :label="$t('signIn.confirmPassword')"
              field="confirmPassword">
              <ArcoInputPassword
                v-model="forgetForm.confirmPassword"
                autocomplete="off"
                :placeholder="$t('signIn.confirmPasswordTips')"/>
            </ArcoFormItem>
            <ArcoFormItem>
              <a-button type="primary" html-type="submit" style="width:100%;margin-top:10px" size="large">
                {{$t('signIn.signIn')}}
              </a-button>
            </ArcoFormItem>
          </ArcoForm>
        </ArcoTabPane>
      </ArcoTabs>
      <ArcoRow justify="space-between">
        <ArcoCol flex="none">
          <ArcoDropdown :trigger="['click']">
            <ArcoButton type="text">
              <ArcoSpace>
                <IconPublic />
                <span>
                {{langStr}}
              </span>
              </ArcoSpace>
            </ArcoButton>
            <template #content>
              <ArcoMenu v-model:selectedKeys="selectedLang" :hide-on-select="false" @menu-item-click="handleLangSelect">
                <ArcoMenuItem key="zhCN">
                  简体中文
                </ArcoMenuItem>
                <ArcoMenuItem key="zhTW">
                  繁體中文
                </ArcoMenuItem>
                <ArcoMenuItem key="enUS">
                  English
                </ArcoMenuItem>
              </ArcoMenu>
            </template>
          </ArcoDropdown>
        </ArcoCol>
        <ArcoCol flex="none">
          <ArcoButton type="text" @click="backToLogin">
            {{$t('signIn.backToLogin')}}
          </ArcoButton>
        </ArcoCol>
      </ArcoRow>
    </div>
  </div>
</template>

<script setup>

import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { computed, onMounted, ref, defineEmits, nextTick } from 'vue'
import config from '@/config'
import api from '@/services/api'
import {
  Message,
  TypographyTitle as ArcoTypographyTitle,
  Tabs as ArcoTabs,
  TabPane as ArcoTabPane,
  Form as ArcoForm,
  FormItem as ArcoFormItem,
  Input as ArcoInput,
  InputPassword as ArcoInputPassword,
  Button as ArcoButton,
  Row as ArcoRow,
  Col as ArcoCol,
  Dropdown as ArcoDropdown,
  Menu as ArcoMenu,
  MenuItem as ArcoMenuItem,
  Space as ArcoSpace
} from '@arco-design/web-vue'
import { IconPublic } from '@arco-design/web-vue/es/icon'
import { COMMON } from '@/store/type'
import { useStore } from 'vuex'

const emits = defineEmits(['signIn'])

const router = useRouter()
const route = useRoute()
const store = useStore()
console.log(route)
const { t } = useI18n()

// 是否禁用短信相关逻辑(短信登录, 忘记密码)
const disableSMSLogin = computed(() => config.DISABLE_SMS_LOGIN === 'true')

const formRef = ref(null)
const langStr = ref('')
const activeLoginType = ref('withPhone')

const emailValidate = async (value, cb) => {
  var emailReg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
  if (value === '') {
    cb(t('signIn.emailNullError'))
  } else if (!emailReg.test(value)) {
    cb(t('signIn.emailRuleError'))
  } else {
    cb()
  }
}

const usernameValidate = async (value, cb) => {
  if (value === '') {
    cb(t('signIn.userNullError'))
  } else {
    cb()
  }
}

const passwordValidate = async (value, cb) => {
  const passwordReg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,20}$/
  if (value === '') {
    cb(t('signIn.passwordNullError'))
  } else if (!passwordReg.test(value)) {
    // } else if (value && value.length < 8) {
    cb(t('signIn.passwordRuleError'))
  } else {
    cb()
  }
}

const phoneValidate = (value, cb) => {
  console.log(value)
  var phoneReg = /0?(1)[0-9]{10}/
  if (!value || value === '') {
    cb(t('signIn.phoneNullError'))
  } else if (!phoneReg.test(value)) {
    cb(t('signIn.phoneRuleError'))
  } else {
    cb()
  }
}

const codeValidate = async (value, cb) => {
  if (!value || value === '') {
    cb(t('signIn.codeRoleError'))
  } else if (value && value.length < 6) {
    cb(t('signIn.codeRoleError'))
  } else {
    cb()
  }
}

const checkConfirm = async (value, cb) => {
  if (value === '') {
    cb(t('signIn.checkPassNullError'))
  } else if (forgetForm.value.password !== value) {
    cb(t('signIn.checkPassDifferentError'))
  } else {
    cb()
  }
}
const forgetForm = ref({})
const forgetRules = ref({
  phone: [{ validator: phoneValidate, required: true }],
  smsCode: [{ validator: codeValidate, required: true }],
  email: [{ validator: emailValidate, required: true }],
  username: [{ validator: usernameValidate, required: true }],
  password: [{ validator: passwordValidate, required: true }],
  confirmPassword: [{ validator: checkConfirm, required: true }]
})
const isInit = ref(false)
const canGetCode = ref(true)
const selectedLang = ref(null)
const timeLeft = ref(0)

onMounted(async () => {
  if (store.state.locale) selectedLang.value = [store.state.locale]
  initForm()
  getLocale()
})

const getCode = async () => {
  try {
    const result = await formRef.value.validateField(['phone'])
    if (result) {
      return
    }
  } catch (error) {
    console.error(error)
    return
  }
  try {
    const res = await api.getCodeWhenSignin({
      areaCode: '+86',
      number: forgetForm.value.phone
    })
    if (res && res.code === 200) {
      Message.success(t('signIn.sendSuccess'))
    } else {
      if (res.detail) {
        Message.error(res.detail)
        return
      }
    }
  } catch (error) {
    console.error(error)
    return
  }
  canGetCode.value = false
  timeLeft.value = 120
  const interval = setInterval(() => {
    timeLeft.value -= 1
    if (timeLeft.value <= 0) {
      canGetCode.value = true
      clearInterval(interval)
    }
  }, 1000)
}

const initForm = () => {
  const email = route.query?.email
  if (email && email.length) {
    isInit.value = true
    activeLoginType.value = 'withEmail'
    forgetForm.value.email = email
  }
}

const layout = ref({
  layout: 'vertical'
})

const signIn = ({ errors, values }, iPhone) => {
  if (!errors) {
    emits('signIn', {
      ...values,
      username: values.username + (values.lastname ? ` ${values.lastname}` : '')
    }, iPhone)
  }
}

const backToLogin = () => {
  const num = Object.keys(route.query)
  console.log(num)
  router.push({
    name: 'Login',
    query: { redirect: window.location.href + `${num && num.length ? '&' : '?'}join=true`, email: route.query.email }
  })
}

const getLocale = () => {
  let locale = ''
  const localeLocal = localStorage.getItem('locale')
  if (localeLocal) {
    locale = localeLocal
  } else {
    const language = (navigator.language ? navigator.language : navigator.userLanguage) || 'zh-CN'
    const languageSplit = language.split('-')
    locale = languageSplit && languageSplit.length > 1 ? languageSplit.join('') : 'zhCN'
  }
  let localeStr = ''
  switch (locale) {
    case 'zhCN':
      localeStr = '简体中文'
      break
    case 'zhTW':
      localeStr = '繁體中文'
      break
    case 'enUS':
      localeStr = 'English'
      break
  }
  langStr.value = localeStr
}

const handleLangSelect = (key) => {
  console.log(key)
  store.dispatch(COMMON.SET_LOCALE, key)
  nextTick(() => {
    getLocale()
  })
}
</script>

<style scoped lang="less">
.sign-in-con {
  padding: 32px;
}
</style>
